<script setup>
import { computed, inject, watch } from 'vue'
import { useStore } from 'vuex'

import DikeProfileCombinedLineChart from '@/components/dikeProfile/DikeProfileCombinedLineChart.vue'

const store = useStore()

const appHeaderHeight = inject('appHeaderHeight')

const ignoreHeight = computed(() => {
  return (appHeaderHeight?.value ?? 0) + 'px'
})

const dikeProfilesElevation = computed(() => store.state.dikeProfiles.dikeProfilesElevation)
const dikeProfiles = computed(() => store.state.dikeProfiles.items)
const loading = computed(() => store.state.dikeProfiles.loadingElevation)
const currentDikeProfile = computed(() => store.state.dikeProfiles.currentItem)
const currentDikeSection = computed(() => store.state.dikeSection.currentItem)

const dikeProfilesShow = computed(() => {
  return dikeProfiles.value && currentDikeSection.value
    ? dikeProfiles.value?.features?.filter(
        (dikeProfile) => dikeProfile.properties.dikesection_id === currentDikeSection.value.id
      )
    : []
})

const dikeProfilesElevationShow = computed(() => {
  return loading.value
    ? dikeProfilesShow.value
    : dikeProfilesElevation.value?.filter(
        (dikeProfile) => dikeProfile.properties.dikesection_id === currentDikeSection.value.id
      )
})

const scrollToElement = (id) => {
  const el = document.getElementById(id)
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  }
}

watch(currentDikeProfile, (val) => {
  if (val) scrollToElement(val.id)
})
</script>
<template>
  <v-card variant="flat">
    <v-alert
      v-if="!dikeProfilesShow || !dikeProfilesShow.length"
      class="ma-3"
      type="info"
      variant="tonal"
      density="compact"
    >
      Select a
      <v-chip label variant="outlined" small class="mr-1 ml-1 pr-2 pl-2">Section</v-chip>
      to fetch the elevation data of the dike profiles
    </v-alert>
    <v-lazy v-else>
      <DikeProfileCombinedLineChart
        v-if="!loading"
        :dike-profiles="dikeProfilesElevationShow"
        :ignore-height="ignoreHeight"
      ></DikeProfileCombinedLineChart>
      <v-progress-linear v-else color="primary" indeterminate />
    </v-lazy>
  </v-card>
</template>
